import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Initializing } from '../../views';

class Website extends Component {
  render() {
    const { isLoading, websites, website } = this.props;

    if (isLoading) {
      return (
        <Initializing />
      );
    }

    if (websites.data.data !== undefined && website === undefined) {
      return (
        <div className="middle-box text-center animated fadeIn">
          <h1>404</h1>
          <h3 className="font-bold">Page Not Found</h3>
          <div className="error-desc">
            Sorry, but this website does not exist.
          </div>
        </div>
      );
    }

    return (
      <div>
        { this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { publisher: { websites } } = state;
  const { routeParams: { websiteName } } = ownProps;
  const website = (websites.data.data || []).find((w) => w.slug === websiteName);

  return { isLoading: websites.loading, websites, website };
};

export default connect(mapStateToProps)(Website);
